var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.414 8.92-7.333-7.332c-1.256-1.256-3.414-.366-3.414 1.414v3.363C6.918 6.537 0 7.653 0 14.752 0 17.825 1.584 20.365 4.068 22c1.547 1.018 3.577-.454 3.008-2.27-1.015-3.236-.517-4.972 5.59-5.328v3.262c0 1.777 2.156 2.673 3.415 1.414l7.333-7.33a2 2 0 0 0 0-2.829m-8.747 8.747v-5.33c-6.855.075-11.56 1.41-9.5 7.984C3.668 19.333 2 17.542 2 14.752c0-5.927 6.7-6.391 12.667-6.417V3L22 10.333z"
  }))));
};
export default SvgShare;